jQuery(document).ready(function ($) {
  //  banner slider
  
var slideCount = $(".slider__banner").find('.slider__main').length;

// Check if there is more than one slide before initializing Slick
if (slideCount > 1) {
  $(".slider__banner").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  });
}

  // service slider
  $(".services_slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // team slider
  $(".ctm-team .cat_listing").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // testimonial slider
  $(".testy_slider").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    swipe: true,
    swipeToSlide: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  });

  // related product
  $(".pdp_related_product_slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    // autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1285,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // metafield tabbing
  $("ul.metas li").click(function () {
    var meta_id = $(this).attr("data-meta");

    $("ul.metas li").removeClass("current");
    $(".meta-content").removeClass("current");

    $(this).addClass("current");
    $("#" + meta_id).addClass("current");
  });

  // loaction accordion
  if ($(window).width() < 750) {
    $(".locations_inner-title .locations_inner-content").hide();
    $(".locations_inner-title > h5").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .siblings(".locations_inner-title .locations_inner-content")
          .slideUp(200);
        $(".locations_inner-title > h5").removeClass("minus").addClass("plus");
      } else {
        $(".locations_inner-title > h5").removeClass("minus").addClass("plus");
        $(this).removeClass("plus").addClass("minus");
        $(".locations_inner-title > h5").removeClass("active");
        $(this).addClass("active");
        $(".locations_inner-title .locations_inner-content").slideUp(200);
        $(this)
          .siblings(".locations_inner-title .locations_inner-content")
          .slideDown(200);
      }
    });
  }

  // change zindex to collection page
  $("details.mobile-facets__disclosure").on("click", function () {
    setTimeout(function () {
      if (
        $(".mobile-facets__disclosure.disclosure-has-popup").hasClass(
          "menu-opening"
        )
      ) {
        $(document).find("aside#main-collection-filters").css("z-index", 9999);
      } else {
        $(document).find("aside#main-collection-filters").css("z-index", 10);
      }
    }, 100);
  });


$(".abtxt_richtext").each(function () {
    var content = $(this);
    var text = content.find("p").text();
    var wordCount = text.trim().split(/\s+/).length;

   var brCount = (text.match(/<br>/g) || []).length;
  wordCount += brCount * 15;

    if (wordCount > 150) {
      content.append('<button class="read-more-btn">Read More</button>');
    } else {
      content.find(".read-more-btn").hide();
    }
  });

  $(document).on("click", ".read-more-btn", function () {
    var content = $(this).closest(".abtxt_richtext");
    content.toggleClass("hide_excess");
    $(this).text(function (i, text) {
      return text === "Read More" ? "Read Less" : "Read More";
    });
  });



});
